import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import origns from './origns'
import homeRouter from './home'
import userCenterRouter from './userCenter'
import clauseRouter from './clause'
import applicationToolRouter from './applicationTool'
import loginRouter from './login'
import companyCenterRouter from './companyCenter'
import ShopRouter from './onlineShop';

Vue.use(Router)

const routers = new Router({
	routes:[
		...homeRouter,
		...userCenterRouter,
		...clauseRouter,
		...applicationToolRouter,
		...loginRouter,
		...companyCenterRouter,
		...ShopRouter,
		...origns
	]
})


routers.beforeEach((to, from, next) => {   
	if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限    
		if (window.localStorage.getItem("TOKENID")!=null) {  // 通过vuex state获取当前的token是否存在store.state.token
            next();
        }
        else { 
        	Vue.prototype.$alert("请登录后访问！");
            next({
				path: '/login',
                query: {redirect:to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
	}
});
routers.afterEach((to, from, next) => {	//路由拦截，每跳转一个新页面后，页面滚动条置顶
	setTimeout(()=>{
		var _hmt = _hmt || [];
		(function() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?9b4a0d21cf8b39efcb831cccaf0ddbce";
		var s = document.getElementsByTagName("script")[0]; 
		s.parentNode.insertBefore(hm, s);
		})();
	},0);
	window.scrollTo(0, 0)
});

export default routers;

axios.defaults.withCredentials=true;

//添加一个请求拦截器
axios.interceptors.request.use(function(config){
	config.url = encodeURI(config.url);
	config.url=Vue.prototype.BASEHOST+config.url;  
	//这里请求加随机数，是为了解决IE的严重缓存 
	if (config.url.indexOf('?')>0){
		config.url=config.url+'&vmf='+Math.random();
	}else{
		config.url=config.url+'?vmf='+Math.random();
	}
	//判断是否存在token
	if (window.localStorage.getItem("TOKENID")!=null){
		Vue.prototype.TOKENID=window.localStorage.getItem("TOKENID");
		config.headers.common['Authorization'] =Vue.prototype.TOKENID; 
	}
	config.headers.post['Content-Type']="application/x-www-form-urlencoded";
	return config;
},function(err){
	return Promise.reject(err);
});

// 添加一个响应拦截器
axios.interceptors.response.use(function(res){ 
	
	if (res.headers['content-type']=='image/jpeg')
	{
		return res.data;//获取图形验证码的响应拦截器
	}
	if(res.data.content == "" || res.data.content == "无"){
		return res.data;
	}
	console.log(res.data);
	if(res.data.state.value == 400){
		Vue.prototype.$alert(res.data.content,'提示');  
		return false
	}else if(res.data.state.value == 401){
		if(!window.alertShow){
			Vue.prototype.$alert(res.data.content, '提示', {
				confirmButtonText: '确定',
				callback:  logoutAction 
			});
			window.alertShow=true;
		}
		return false
	}else if(res.data.state.value == 403){
		Vue.prototype.$alert(res.data.content,'提示');
		return false
	}else if(res.data.state.value == 404){
		Vue.prototype.$alert(res.data.content,'提示');
		return false
	}else if(res.data.state.value == 500){
		if(res.data.content == "请您登录企业号使用！"){
			Vue.prototype.$alert(res.data.content, '提示', {
				confirmButtonText: '确定',
				callback:  logoutAction 
			});
		}else{
			Vue.prototype.$alert(res.data.content,'提示');
		}
		return false
	}else if(res.data.state.value == 1){
		Vue.prototype.$alert(res.data.content,'提示');		
		return false
	}


return res.data;
},function(err){
	//console.log(err.response);
	if(err.response.status == 400){
		Vue.prototype.$alert("参数不对"); 
		return false
	}else if(err.response.status == 401){
		Vue.prototype.$alert(err.response.data.content);
		return false
	}else if(err.response.status == 403){
		Vue.prototype.$alert("拒绝访问"+ err.response.data.content);
		return false
	}else if(err.response.status == 404){
		Vue.prototype.$alert(`请求地址出错: ${err.response.config.url}`);
		return false
	}else if(err.response.status == 500){
		console.error(err);
		Vue.prototype.$alert("服务器开了个小差，请稍后再试");
		return false
	}
return Promise.reject(err);
})

function logoutAction(){
	window.localStorage.removeItem("TOKENID");
	Vue.prototype.Bstore.commit("setuserName","");
	Vue.prototype.Bstore.commit("setshowName","");  
	Vue.prototype.Bstore.commit("settoken","");  
	Vue.prototype.Bstore.commit("setmessageNum","");  
	Vue.prototype.Bstore.commit("setusertype","");  
	Vue.prototype.Bstore.commit("setimgSrc",""); 
	Vue.prototype.Bstore.commit("setregType",""); 
	routers.replace({
		path: 'login',
		query: {redirect: routers.currentRoute.fullPath}
	})
	delete window.alertShow
}



// WEBPACK FOOTER //
// ./src/router/index.js